export default "__VITE_ASSET__51dd8bde__"